<template lang="pug">
	#sfc-main-container(:class="contentClass")
		sfc-sentry
		sfc-gtm-body
		sfc-dfp
		sfc-heap
		#sfc-main-content
			b-container(fluid)
				b-row
					b-col
						nuxt
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.container-fluid
		padding: 0
		> .row
			margin: 0
			> .col
				padding: 0

</style>

<script>
export default {
	computed: {
		contentClass(){
			return {
				'mt-0': this.layout == "blank"
			}
		}
	},
	data(){
		let layout = this.$route.query.layout

		return{
			layout
		}

	}
}
</script>
